import { render } from "./vendor_payment.vue?vue&type=template&id=70718392"
import script from "./vendor_payment.vue?vue&type=script&lang=js"
export * from "./vendor_payment.vue?vue&type=script&lang=js"

import "./vendor_payment.vue?vue&type=style&index=0&id=70718392&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__